import { useState } from 'react';
import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import { getFormDefaultValue, getTableHeaders } from '../../utils/forms/FormDataModel';
import { ContentItem, OnAddArguments, TabContent } from '../../utils/forms/FormInterface';
import AbstractForm from '../Entity/AbstractForm';
import AbstractLanding from '../Entity/AbstractLanding';
import AbstractTabs, { TabActiosEventType, TabActiosProps } from '../Entity/AbstractTabs';
import { NEWS_ARTICLE_ENTITY } from '../../constants/EntityName';
import { NewsArticleFormData } from '../../datamodels/NewsArticle';

const NewsManagementPage = () => {
  const [activeKey, setActiveKey] = useState<string>('0');
  const [tabTitle, setTabTitle] = useState<string>('Add News Article');
  const [showFormComponent, setShowFormComponent] = useState<boolean>(false);
  // Use a counter so multiple refresh triggers can't cancel each other out
  const [refreshData, setRefreshData] = useState<number>(0);
  const [content, setContent] = useState<TabContent>([]);

  const defaultFormValue: any = getFormDefaultValue(NewsArticleFormData);
  const tableHeaders: any = getTableHeaders(NewsArticleFormData);
  const addName = 'News Article';
  const headerName = 'Newsroom Management';

  const bumpTableRefresh = () => {
    setRefreshData((prev) => prev + 1);
  };

  const onSuccessful = (id?: string) => {
    if (id === 'create') {
      setShowFormComponent(false);
    }
    onTabClick('0');
    bumpTableRefresh();
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1) {
      const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
      checkArr.length ? null : onAdd(argument1);
    } else {
      setShowFormComponent(true);
      setTabTitle('Add News Article');
      onTabClick('a');
    }
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent((content) => content.filter((item) => item.key !== key));
    setActiveKey('0');
    if (shouldRefresh) {
      bumpTableRefresh();
    }
    if (key === 'a') {
      setShowFormComponent(false);
    }
  };

  const additionalEntityName = [{ name: NEWS_ARTICLE_ENTITY, getAllResponse: true }];

  const onAdd = (argument1: OnAddArguments) => {
    const newObj = {
      key: argument1.id,
      tabTitle: `Edit News #${argument1.id}`,
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            headerName={headerName}
            entityName={NEWS_ARTICLE_ENTITY}
            additionalEntityName={additionalEntityName}
            formTemplate={NewsArticleFormData}
            formDefaultPayload={getFormDefaultValue(NewsArticleFormData)}
            onSuccessfulUpdate={onSuccessful}
            formHeader=""
            showDeleteDraft={true}
            closeTab={closeTab}
          />
        </GenericAccordian>
      ),
    };

    setContent((prev: any) => [...prev, newObj]);
    if (argument1.id) {
      setActiveKey(String(argument1.id));
    }
  };

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType,
  ) => {
    if (action === 'remove') {
      if (targetKey === 'a') {
        setShowFormComponent(false);
        onTabClick('0');
      } else {
        onTabClick('0');
        setContent((content) => content.filter((item) => String(item.key) !== targetKey));
      }
    }
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName="Newsroom Articles"
      updateFormVisibility={updateFormVisibility}
      onTabClick={onTabClick}
      secondTabTitle={tabTitle}
      showFormComponent={showFormComponent}
      content={content}
      formComponent={
        <GenericAccordian>
          <AbstractForm
            isCreateMode={true}
            headerName={headerName}
            entityName={NEWS_ARTICLE_ENTITY}
            additionalEntityName={additionalEntityName}
            formTemplate={NewsArticleFormData}
            formDefaultPayload={defaultFormValue}
            onSuccessfulUpdate={onSuccessful}
            closeTab={closeTab}
          />
        </GenericAccordian>
      }
    >
      <AbstractLanding
        headerName={headerName}
        addName={addName}
        entityName={NEWS_ARTICLE_ENTITY}
        tableHeaders={tableHeaders}
        onAdd={onAddNew}
        refreshData={refreshData}
      />
    </AbstractTabs>
  );
};

export default NewsManagementPage;
